import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	type EmblaCarouselType,
	type EmblaOptionsType,
} from 'embla-carousel'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import { addPrevNextBtnsClickHandlers } from '@/scripts/core/embla-functions'

export class SliderComponent extends UcoastEl {
	static htmlSelector = 'slider-component'
	uniqueId: string
	emblaApi?: EmblaCarouselType
	prevButton?: HTMLButtonElement
	nextButton?: HTMLButtonElement
	constructor() {
		super()
		this.uniqueId = q.ra(this, 'data-unique-id')
		this.prevButton = q.os('[data-slider-buttons] button[name="previous"]', this)
		this.nextButton = q.os('[data-slider-buttons] button[name="next"]', this)
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	initializeSlider() {
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'start',
			containScroll: 'keepSnaps',
			dragFree: true,
			duration: 20,
			dragThreshold: 20,
			loop: false,
		}

		const viewportNode = q.rs('[data-slider-viewport]', this)
		console.log({ viewportNode })
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		this.emblaApi = emblaApi
		if (this.prevButton && this.nextButton) {
			const removePrevNextBtnsClickHandlers =
				addPrevNextBtnsClickHandlers(
					emblaApi,
					this.prevButton,
					this.nextButton
				)
			this.emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
		}
	}
}
